export const DEV_ENV = "development";
export const VP_ENV = process.env.VP_ENV || DEV_ENV;

// The React Native parts have a general __DEV__ constant, that can be used.
// This constant is used in non-RN parts of the code.
export const IS_DEV = VP_ENV === DEV_ENV;
